function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 23C18.9706 23 23 18.9706 23 14C23 9.02944 18.9706 5 14 5C12.8003 5 11.5003 5.34133 11.0003 5.512C7.50458 6.74741 5 10.0812 5 14C5 18.9706 9.02944 23 14 23Z",
  fill: "#FFAF00",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3C11.7239 3 11.5 3.22386 11.5 3.5C11.5 3.77614 11.7239 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 8.75681 5.92992 5.9633 8.7061 4.70729C8.95769 4.59346 9.06937 4.29723 8.95555 4.04564C8.84172 3.79405 8.54549 3.68237 8.2939 3.79619C5.17303 5.20816 3 8.34977 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM12.5 8.99C12.5 8.71386 12.2761 8.49 12 8.49C11.7239 8.49 11.5 8.71386 11.5 8.99V9.01C11.5 9.28614 11.7239 9.51 12 9.51C12.2761 9.51 12.5 9.28614 12.5 9.01V8.99ZM11 10.5C10.7239 10.5 10.5 10.7239 10.5 11C10.5 11.2761 10.7239 11.5 11 11.5H11.5V15C11.5 15.2761 11.7239 15.5 12 15.5H13C13.2761 15.5 13.5 15.2761 13.5 15C13.5 14.7239 13.2761 14.5 13 14.5H12.5V11C12.5 10.7239 12.2761 10.5 12 10.5H11Z",
  fill: "#FFAF00"
});
const SvgAboutus = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAboutus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/aboutus.cc2bd189.svg";
export { ForwardRef as ReactComponent };